import tripsData from '../data/trips.json';

const STORAGE_KEY = 'scrapost_trips_data_v3';

const tripService = {
    // Initialize data from JSON if not in localStorage
    initialize: () => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(tripsData));
            return tripsData;
        }
        return JSON.parse(stored);
    },

    // Get all trips
    getTrips: () => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
        // Fallback to initialization if somehow empty
        localStorage.setItem(STORAGE_KEY, JSON.stringify(tripsData));
        return tripsData;
    },

    // Get a specific trip by ID
    getTrip: (id) => {
        const trips = tripService.getTrips();
        return trips.find(t => t.id === id);
    },

    // Save a trip (update existing)
    saveTrip: (updatedTrip) => {
        const trips = tripService.getTrips();
        const index = trips.findIndex(t => t.id === updatedTrip.id);

        if (index !== -1) {
            trips[index] = updatedTrip;
            localStorage.setItem(STORAGE_KEY, JSON.stringify(trips));
            return true;
        }
        return false;
    },

    // Reset data to original JSON (useful for testing/debugging)
    resetData: () => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(tripsData));
        return tripsData;
    }
};

export default tripService;
